import Cookie from 'js-cookie';
import Ajax from './ajax';
import Log from './log';

const Auth = {
  validUsername(username) {
    return username.match(/^[a-zA-Z0-9]+([_a-zA-Z0-9])*$/i);
  },

  signout(userStore, options = { redirectToRoot: true }) {
    let resp = Ajax.post({
      url: `/sessions/x`,
      data: {
        _method: 'DELETE',
      },
    });

    resp.then(() => {
      userStore.set({});

      if (options.redirectToRoot) {
        location.href = '/';
      }
    });

    return resp;
  },

  load(userStore, token) {
    if (!token || token === '') {
      return;
    }

    let resp = Ajax.post({
      url: '/users/me',
      withDataProcessing: false,
      data: { api_token: token },
    });

    resp
      .then((data) => {
        if (data && (data.id || data.name)) {
          userStore.set(data);

          Cookie.set('current_user_datetime', new Date().toString(), {
            expires: 360,
          });
        }
      })
      .catch((err) => {
        Log.track(`[LOAD USER] [1] (${token}) | ${err}`);
      });

    return resp;
  },

  signIn(email, password) {
    Log.track(`[AUTH SIGN IN] [1] email: ${email}, password: ${password && password.length > 0 ? 'YES' : 'NO'}`);

    return Ajax.post({
      url: '/sessions',
      data: {
        email: email,
        password: password,
      },
    });
  },
};

export default Auth;
